import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

loadEnvironment('assets/env.json', environment, () => {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
});
// TODO: move to a new @evonik package

function loadEnvironment(
  url: string,
  result: object,
  done: () => void,
  failed?: () => void,
): void {
  const request = new XMLHttpRequest();
  request.open('GET', url);

  request.onload = function () {
    const environmentConfig = JSON.parse(request.response);
    console.log('loadEnvironment', environmentConfig);
    Object.entries(environmentConfig).map(([key, value]) => {
      if (
        key.toLocaleLowerCase().includes('url') ||
        key.toLocaleLowerCase().includes('uri')
      ) {
        const urlObj = new URL(value as string);

        if (urlObj.protocol === 'http:') {
          urlObj.protocol = 'https:';
        }
        value = urlObj.toString();
      }
      result[key] = value;
    });

    done();
  };

  request.onerror = function () {
    console.error(
      "Cannot load 'env.json' from the remote. Are you using the Angular dev server? Don't forget to rename 'assets/env.json.example'.",
    );

    if (failed) {
      failed();
    }
  };

  request.send();
}
